import { isString } from 'lodash';

import { BaseModel } from '@classes/base-model';

export type RawDeliveryPeriodModel = Omit<
  DeliveryPeriodModel,
  'fixDate' | 'reservationDate'
> & {
  fixDate: string;
  reservationDate: string;
};

/**
 * Class that represents DeliveryPeriodSchema
 */
export class DeliveryPeriodModel extends BaseModel {
  constructor(
    originalValue?:
      | Partial<DeliveryPeriodModel>
      | Partial<RawDeliveryPeriodModel>,
  ) {
    super(originalValue);

    if (isString(originalValue?.fixDate)) {
      this.fixDate = new Date(originalValue.fixDate);
    }

    if (isString(originalValue?.reservationDate)) {
      this.reservationDate = new Date(originalValue.reservationDate);
    }
  }

  /**
   * Determines whether the document is considered active or not
   */
  active?: boolean;

  _id?: string;

  /**
   * The delivery period label
   */
  label: string;

  /**
   * The last date items should be shipped to the customer. This is an ISO date/time object. This property should be communicated to the backend in the local time of the user.
   */
  fixDate?: Date;

  /**
   * The first available date items should be shipped to the customer. This is an ISO date/time object. This property should be communicated to the backend in the local time of the user.
   */
  reservationDate?: Date;

  /**
   * Method that sets fixDate to provided value
   */
  setFixDate(date: Date) {
    this.fixDate = date;
  }

  /**
   * Method that sets setReservationDate to provided value
   */
  setReservationDate(date: Date) {
    this.reservationDate = date;
  }
}
